import moment from "moment";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { db } from "../components/Firebase";
import sendFirebaseNotification from "../components/sendFirebaseNotification";

const CreateNotification = () => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const navigate = useNavigate();

  const Button = styled.button`
    background-color: black;
    color: white;
    font-size: 20px;
    padding: 10px 60px;
    border-radius: 5px;
    margin: 10px 0px;
    cursor: pointer;
  `;
  const onSubmit = () => {
    if (title && content) {
      db.collection("notification")
        .add({
          title: title,
          content: content,
          date: moment().format("D MMM, YYYY"),
        })
        .then((i) => {
          sendFirebaseNotification("notification",'',{body:content,title})
          navigate("/dashboard/notification");
          setContent("");
          setTitle("");

        });
    } else {
      return alert("please fill the form");
    }
  };
  return (
   <div class="container-fluid">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h1 style={{ textAlign: "center" }}>Create Notification</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
          <div class="form-group">
            <label class="form-control-label">Title:</label>
            <input type="text" class="form-control" value={title} onChange={(e) => { setTitle(e.target.value); }} />
          </div>
          <div class="form-group">
            <label class="form-control-label">Content:</label>
            <textarea class="form-control" value={content} onChange={(e) => { setContent(e.target.value);}} multiple></textarea>
          </div>
          
          <button class="btn btn-primary" onClick={onSubmit}>Submit</button>
      </div>
    </div>

  </div>
</div>
  );
};

export default CreateNotification;
